import { Animal } from '@/modules/score-type/@types';
import { jsonApiClient } from 'shared/model';

const api = jsonApiClient('Animal');

export const getAnimals = (id: string, signal?: AbortSignal) => api.get<Animal[]>(id, { signal });
